import api from '../api';
import { ENDPOINTS } from '../../constants/apiEndpoints';

export const fetchTermDepositAccountsUrl = () => {
  return api.get(ENDPOINTS.fetch_term_deposits_accounts.url);
};